import { AboutUs } from "landing";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const AboutUsPage: NextPage = () => {
	return (
		<>
			<NextSeo title="Mango GIS - About Us" />
			<AboutUs />
		</>
	);
};

export default AboutUsPage;
